import {Popconfirm as AntdPopconfirm} from 'antd';
import styled from 'styled-components';

const StyledPopconfirm = styled(AntdPopconfirm)``;

export const Popconfirm = StyledPopconfirm;
